import React from "react";
import DevelopBannerSection from "../components/Homepage/DevelopPageComponents/DevelopBannerSection";
import Industries from "../components/Homepage/IndustriesSection/Industries";
import VntWork from "../components/ServicesPageComponents/VntWork";
import DevDiff from "../components/Homepage/DevelopPageComponents/DevDiff";
import { Accodion } from "../components/Accordion/AccordionItem";
import FaqVideo from "../components/FaqVideo/FaqVideo";
import TransparentRoundedBtn from "../components/CTA/TransparentRoundedBtn";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import WorkSliderItem from "../components/ServicesPageComponents/WorkSliderItem";
import IndusExpert from "../components/IndustriesPageComponents/IndusExpert";
import BlogSection from "../components/BlogPosts/BlogSection";
import { float1, float2, sanyogprofileImg, slidee1, slidee2, slidee3, slidee4, slidee5, slidee6} from "../components";
import ServiceOfferSection from "../components/WebAppPageComponents/ServiceOfferSection";
function WebAppDev() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    speed: 800,
    adaptiveHeight: false,
    infinite: true,
    useTransform: true,
    cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="devlopPage" id="devlopPage">
        <div className="devTopSection webBg">
          <DevelopBannerSection
            line1="Web Application"
            line2="Development"
            line3="Services"
            BannerPara="Our proficient team utilizes the latest technologies including PHP, Web 2.0, HTML, WordPress, Drupal, Magento, React, Angular, NuxtJS, NextJS and other stack to craft responsive and customized web applications for your business. "
          />
          <div className="shapeSvg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
              <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer" />
                <path
                  className="fil0"
                  d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
                />
              </g>
            </svg>
          </div>
        </div>
        <section id="servicesOfferSection" className="servicesOfferSection">
          <ServiceOfferSection />
        </section>
        <section id="industriesSection" className="industriesSection">
          <div className="rightTop"></div>
          <Industries
            char1="Industries"
            char2="We Serve"
            secPara="We have honed our skills in developing advanced web platforms,
        mobile applications, and intricate systems that align with the
        latest industry trends."
            icon1="health_and_safety"
            cardTitle1="Healthcare"
            cardDesc1="We provide custom web app development services from startups to enterprises that helps in solving complex challenges with reliable and agile digital solutions."
            cardLink1="/healthcare"
            icon2="school"
            cardTitle2=" Education"
            cardDesc2="We help your web applications stay relevant by adopting and addressing changing business requirements. We also help with pro-active safety and performance optimization strategies."
            cardLink2="/education-software-development-company"
            icon3="account_balance"
            cardTitle3="Fintech"
            cardDesc3="We offer end-to-end software product engineering & development services. Our teams align your requirements and forge in building high quality & scalable products."
            cardLink3="/fin-tech"
            icon4="volunteer_activism"
            cardTitle4="Manufacturing"
            cardDesc4="We offer on-demand website app developers across a variety of technologies for ease of scalability, reduced time-to-market and enhanced ROI. Setup your web development team from scratch or extend an existing team with ease."
            cardLink4="#"
            icon5="inventory"
            cardTitle5="FMCG"
            cardDesc5="Choose our eCommerce development services to transform your ideas into reality, unlock new opportunities, and achieve unparalleled success in the online marketplace. Contact us today to discuss your project requirements and let us help you eCommerce presence."
            cardLink5="#"
            icon6="storefront"
            cardTitle6="Real-estate"
            cardDesc6="Experience seamless modernization and migration services with our company. We specialize in revitalizing legacy applications by leveraging cutting-edge web and cloud technologies. Enhance ROI and reduce ongoing management costs."
            cardLink6="#"
          />
          <div className="leftBtm"></div>
        </section>
        <section className="wntWorkSection">
          <div className="container">
            <VntWork
              subText="Web application"
              mainText="development process"
              paratext="The web application development process typically involves several stages, including:"
            />
            <div className="row justify-content-center">
              <div className="col-lg-10 col-md-12 col-12">
                <div className="workSliderWrapper">
                  <Slider {...settings} className="sliderWork slider-with-gap">
                    <div className="slide-item">
                      <WorkSliderItem
                        title="Requirement Gathering"
                        number="1"
                        sliderDesc="In this initial phase, the development team works closely with the client to gather detailed requirements and understand the objectives, functionality, and target audience of the web application."
                        slideImg={slidee1}
                      />
                    </div>

                    <div className="slide-item">
                      <WorkSliderItem
                        title="Planning and Design"
                        number="2"
                        sliderDesc="Based on the gathered requirements, the development team creates a plan and designs the architecture of the web application. This includes defining the technology stack, database structure, user interface (UI) design, and user experience (UX) considerations."
                        slideImg={slidee2}
                      />
                    </div>
                    <div className="slide-item">
                      <WorkSliderItem
                        title="Development"
                        number="3"
                        sliderDesc="This phase involves actual coding and development of the web application. The development team follows best practices and coding standards to build the core features, integrate necessary functionalities, and ensure compatibility across different devices and browsers."
                        slideImg={slidee3}
                      />
                    </div>
                    <div className="slide-item">
                      <WorkSliderItem
                        title="Testing"
                        number="4"
                        sliderDesc="Quality assurance and testing are crucial to identify and fix any bugs or issues in the web application. This phase includes functional testing, usability testing, performance testing, security testing, and compatibility testing to ensure the application meets the required standards."
                        slideImg={slidee4}
                      />
                    </div>
                    <div className="slide-item">
                      <WorkSliderItem
                        title="Deployment"
                        number="5"
                        sliderDesc="Once the web application has passed the testing phase, it is deployed to a production environment. This involves setting up servers, databases, and configurations required to make the application accessible to users."
                        slideImg={slidee5}
                      />
                    </div>
                    <div className="slide-item">
                      <WorkSliderItem
                        title="Maintenance and Support"
                        number="6"
                        sliderDesc="After deployment, ongoing maintenance and support are provided to address any issues, perform updates, and make enhancements to the web application. This ensures the application remains functional, secure, and up-to-date."
                        slideImg={slidee6}
                      />
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
            
          </div>
        </section>
        <section className="whatMakesSection" id="whatMakesSection">
          <DevDiff
            float1={float1}
            float2={float2}
            Char1="What Makes"
            Char2="us"
            Char3="Different?"
            diffDescription="We pride ourselves on our unique approach and what sets us apart from other web app development companies. Our commitment to excellence and customer satisfaction has earned us a reputation as a leading industry expert. "
          />
        </section>
        <section className="IndusExpertSection">
          <IndusExpert
            cName="Version Next Technologies"
            cSecTitle="Why Hire Version Next Technologies as Web App Development?"
            profileName="Mr. Sanyogg Shelar"
            designation="Buisness Head"
            cardTitle1="Quality Assurance"
            cardData1="We have a dedicated team of quality assurance professionals who rigorously test and validate every aspect of the web application to ensure its functionality, performance, and security."
            cardTitle2="Timely Delivery"
            cardData2="We adhere to strict timelines and milestones to ensure the timely delivery of web applications. Our project management processes and experienced team allow us to meet deadlines and deliver on time."
            cardTitle3="Scalability"
            cardData3="Our solutions are built with scalability in mind, allowing your application to handle increasing user loads and data volumes effectively."
            cardTitle4="Ongoing Support"
            cardData4="We provide ongoing support and maintenance services to ensure the smooth functioning of web applications post-development."
            profileImg={sanyogprofileImg}
            facebookLink="https://profiles.wordpress.org/codexdemon/"
            facebookIcon="fab fa-wordpress"
            twiiterLink="https://twitter.com/sanyog"
            twitterIcon="fab fa-twitter-square"
            linkdinLink="https://www.linkedin.com/in/sanyogs"
            linkdinIcon="fab fa-linkedin"
          />
        </section>
        <section className="commonFaq">
          <div className="container">
            <div className="sectionTitle">
              <h2>
                Frequently Asked <span className="textGrade">Questions</span>
              </h2>

              <p>
                Singling out common points and possible difficulties which can
                be encountered in EHR, EMR, and Patient Portal software
                development
              </p>
            </div>
            <div className="row">
              <div className="col-md-12 col-lg-6 col-12">
                <Accodion />
              </div>
              <div className="col-md-12 col-lg-6 col-12">
                <FaqVideo />
              </div>
            </div>
            <div className="readMoreBtnWrap">
              <TransparentRoundedBtn
                rText="Read More"
                rLink="/faqs"
                rName="rAnimeBtn readMoretBtn"
              />
            </div>
          </div>
        </section>
        <BlogSection />
      </div>
    </>
  );
}

export default WebAppDev;
